import { useState } from 'react'

import Client from './Client'

export default function useClient(): Client {
  const [client] = useState(new Client())

  return client
}
